module.exports = __webpack_public_path__ + "img/invite_award_info2.6f04581e.png";